import { useState } from "react";
import { Search } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FaqSection({ faqs }) {
  const { t } = useSite();
  const [q, setQ] = useState("");
  const shown = faqs.filter((f) => (f.question + f.answer).toLowerCase().includes(q.toLowerCase()));
  return (
    <section id="faq" className="border-t border-slate-200 bg-white py-16 sm:py-24" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-4">
          <p className="eyebrow mb-4">{t("faq.eyebrow")}</p>
          <h2 className="text-3xl font-bold tracking-tight text-[#0F2B48] lg:text-4xl">{t("faq.title")}</h2>
          <div className="relative mt-8">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("faq.search")} data-testid="faq-search-input"
              className="w-full border border-slate-300 bg-[#FAF9F6] py-3 pl-10 pr-4 text-sm outline-none focus:border-[#D97706]" />
          </div>
        </div>
        <Accordion type="single" collapsible className="lg:col-span-7 lg:col-start-6">
          {shown.map((f) => (
            <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
              <AccordionTrigger className="text-left text-base font-semibold text-[#0F2B48]">{f.question}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
          {!shown.length && <p className="text-sm text-slate-500">{t("faq.empty")}</p>}
        </Accordion>
      </div>
    </section>
  );
}
